import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Section } from '@scope/scope-one-ui/core';
import { TotalOutputLoss } from './TotalOutputLoss';
import { PageData } from '../../types/climateStressTest';
import { ValueChainDistribution } from './ValueChainDistribution';

const chips = ['TOTAL OUTPUT LOSS', 'VALUE-CHAIN DISTRIBUTION OF OUTPUT LOSSES'];

export const ClimateChangeRisk: FC<PageData> = (pageData) => {
  const { t } = useTranslation();

  return (
    <Section header={t('Climate change risk')} chips={chips}>
      <Box display="flex" flexDirection="column" gridGap={4}>
        <TotalOutputLoss {...pageData} />
        <ValueChainDistribution {...pageData} />
      </Box>
    </Section>
  );
};
